var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "StoryTitle" } }, [
    _c(
      "div",
      {
        staticClass:
          "block-title-container d-flex flex-row justify-content-center align-items-center",
      },
      [
        _c(
          "IconButton",
          {
            attrs: {
              "on-click": function () {
                return _vm.$router.push("/chatbot/stories")
              },
            },
          },
          [
            _c("span", { staticClass: "material-icons cb-back-button" }, [
              _vm._v(" chevron_left "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          ref: "editStoryName",
          attrs: { placeholder: _vm.$t("chatbotv2.typeStoryTitle") },
          domProps: { value: _vm.storyName },
          on: {
            input: function ($event) {
              _vm.storyName = $event.target.value
            },
            blur: function ($event) {
              return _vm.updateName()
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "representative-container" },
          _vm._l(_vm.filteredChatbotStoryViewActivity, function (user) {
            return _c(
              "a-button",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { content: _vm.users[user.userId].name },
                    expression: "{ content: users[user.userId].name }",
                  },
                ],
                key: user.userId,
                attrs: { placement: "bottom" },
              },
              [
                _c("span", { staticClass: "representative-online" }),
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.users[user.userId].name.substring(0, 10) + "..."
                    ) +
                    "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }